import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-[#666666] text-white">
      <div className="container mx-auto px-4 py-16 max-w-7xl">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12">
          <div>
            <h3 className="text-xl font-bold mb-4">おかやま国際人材派遣株式会社</h3>
            <ul className="space-y-3 text-sm">
              <li className="flex items-start gap-2">
                <i className="ri-map-pin-line text-lg flex-shrink-0 mt-0.5"></i>
                <span className="text-white/80">岡山市北区○○町1-2-3</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-phone-line text-lg flex-shrink-0"></i>
                <a href="tel:086-012-3456" className="text-white/80 hover:text-white transition-colors whitespace-nowrap">
                  086-012-3456
                </a>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-printer-line text-lg flex-shrink-0"></i>
                <span className="text-white/80 whitespace-nowrap">FAX: 086-012-3457</span>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-4">サービス</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/services" className="text-white/80 hover:text-white transition-colors text-sm whitespace-nowrap">
                  事業内容
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-white/80 hover:text-white transition-colors text-sm whitespace-nowrap">
                  会社概要
                </Link>
              </li>
              <li>
                <Link to="/careers" className="text-white/80 hover:text-white transition-colors text-sm whitespace-nowrap">
                  求人情報
                </Link>
              </li>
              <li>
                <Link to="/blog" className="text-white/80 hover:text-white transition-colors text-sm whitespace-nowrap">
                  お知らせ
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-4">フォローする</h4>
            <div className="flex gap-4">
              <a
                href="https://facebook.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-white/10 hover:bg-white/20 rounded-full flex items-center justify-center transition-all duration-300 cursor-pointer"
              >
                <i className="ri-facebook-fill text-xl"></i>
              </a>
              <a
                href="https://instagram.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-white/10 hover:bg-white/20 rounded-full flex items-center justify-center transition-all duration-300 cursor-pointer"
              >
                <i className="ri-instagram-line text-xl"></i>
              </a>
              <a
                href="https://line.me"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-white/10 hover:bg-white/20 rounded-full flex items-center justify-center transition-all duration-300 cursor-pointer"
              >
                <i className="ri-line-fill text-xl"></i>
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-white/20 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-white/60 text-sm">
              &copy; 2024 おかやま国際人材派遣株式会社. All rights reserved.
            </p>
            <a
              href="https://readdy.ai/?ref=logo"
              target="_blank"
              rel="noopener noreferrer"
              className="text-white/60 hover:text-white text-sm transition-colors whitespace-nowrap"
            >
              Powered by Readdy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
